// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/update_my_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { EyeColor } from "../general/eye_color_pb";
import { file_general_eye_color } from "../general/eye_color_pb";
import type { HairColor } from "../general/hair_color_pb";
import { file_general_hair_color } from "../general/hair_color_pb";
import type { Gender } from "../general/gender_pb";
import { file_general_gender } from "../general/gender_pb";
import type { Ethnicity } from "../general/ethnicity_pb";
import { file_general_ethnicity } from "../general/ethnicity_pb";
import type { SpokenLanguage } from "../general/spoken_language_pb";
import { file_general_spoken_language } from "../general/spoken_language_pb";
import type { ShowcaseLayoutType } from "./showcase_layout_type_pb";
import { file_accounts_showcase_layout_type } from "./showcase_layout_type_pb";
import type { ProfileCoverType } from "./profile_cover_type_pb";
import { file_accounts_profile_cover_type } from "./profile_cover_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/update_my_account.proto.
 */
export const file_accounts_update_my_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_general_work_function, file_general_work_location, file_general_eye_color, file_general_hair_color, file_general_gender, file_general_ethnicity, file_general_spoken_language, file_accounts_showcase_layout_type, file_accounts_profile_cover_type]);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest
 */
export type UpdateMyAccountRequest = Message<"protos.accounts.UpdateMyAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.UpdateMyAccountRequest.Params params = 1;
   */
  params?: UpdateMyAccountRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.
 * Use `create(UpdateMyAccountRequestSchema)` to create a new message.
 */
export const UpdateMyAccountRequestSchema: GenMessage<UpdateMyAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest.Params
 */
export type UpdateMyAccountRequest_Params = Message<"protos.accounts.UpdateMyAccountRequest.Params"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string bio = 2;
   */
  bio: string;

  /**
   * @generated from field: string pfp_path = 3;
   */
  pfpPath: string;

  /**
   * @generated from field: repeated protos.accounts.UpdateMyAccountRequest.Params.Cover covers = 4;
   */
  covers: UpdateMyAccountRequest_Params_Cover[];

  /**
   * @generated from field: string contact_email = 5;
   */
  contactEmail: string;

  /**
   * @generated from field: string contact_phone_number = 6;
   */
  contactPhoneNumber: string;

  /**
   * @generated from field: string contact_website = 7;
   */
  contactWebsite: string;

  /**
   * @generated from field: protos.accounts.ShowcaseLayoutType showcase_layout_type = 8;
   */
  showcaseLayoutType: ShowcaseLayoutType;

  /**
   * @generated from field: protos.accounts.UpdateMyAccountRequest.Params.WorkFunctionData main_work_function = 9;
   */
  mainWorkFunction?: UpdateMyAccountRequest_Params_WorkFunctionData | undefined;

  /**
   * @generated from field: repeated protos.accounts.UpdateMyAccountRequest.Params.WorkFunctionData other_work_functions = 10;
   */
  otherWorkFunctions: UpdateMyAccountRequest_Params_WorkFunctionData[];

  /**
   * @generated from field: string default_project_cover_path = 11;
   */
  defaultProjectCoverPath: string;

  /**
   * @generated from field: uint32 info_sheet_height = 12;
   */
  infoSheetHeight: number;

  /**
   * @generated from field: uint32 info_sheet_on_screen_age_start = 13;
   */
  infoSheetOnScreenAgeStart: number;

  /**
   * @generated from oneof protos.accounts.UpdateMyAccountRequest.Params.optional_info_sheet_on_screen_age_end
   */
  optionalInfoSheetOnScreenAgeEnd: {
    /**
     * @generated from field: uint32 info_sheet_on_screen_age_end = 14;
     */
    value: number;
    case: "infoSheetOnScreenAgeEnd";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: protos.general.EyeColor info_sheet_eye_color = 15;
   */
  infoSheetEyeColor: EyeColor;

  /**
   * @generated from field: protos.general.HairColor info_sheet_hair_color = 16;
   */
  infoSheetHairColor: HairColor;

  /**
   * @generated from field: protos.general.Gender info_sheet_gender = 17;
   */
  infoSheetGender: Gender;

  /**
   * @generated from field: protos.general.Ethnicity info_sheet_ethnicity = 18;
   */
  infoSheetEthnicity: Ethnicity;

  /**
   * @generated from field: repeated protos.accounts.UpdateMyAccountRequest.Params.InfoSheetLanguage info_sheet_spoken_languages = 19;
   */
  infoSheetSpokenLanguages: UpdateMyAccountRequest_Params_InfoSheetLanguage[];

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 20;
   */
  mainWorkLocation: WorkLocation;

  /**
   * We'll remove these in the future so use higher numbers
   *
   * @generated from field: string social_links_instagram = 101;
   */
  socialLinksInstagram: string;

  /**
   * @generated from field: string social_links_facebook = 102;
   */
  socialLinksFacebook: string;

  /**
   * @generated from field: string social_links_linkedin = 103;
   */
  socialLinksLinkedin: string;

  /**
   * @generated from field: string social_links_imdb = 104;
   */
  socialLinksImdb: string;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.Params.
 * Use `create(UpdateMyAccountRequest_ParamsSchema)` to create a new message.
 */
export const UpdateMyAccountRequest_ParamsSchema: GenMessage<UpdateMyAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0, 0);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest.Params.Cover
 */
export type UpdateMyAccountRequest_Params_Cover = Message<"protos.accounts.UpdateMyAccountRequest.Params.Cover"> & {
  /**
   * @generated from oneof protos.accounts.UpdateMyAccountRequest.Params.Cover.cover
   */
  cover: {
    /**
     * @generated from field: protos.accounts.UpdateMyAccountRequest.Params.CoverImage cover_image = 1;
     */
    value: UpdateMyAccountRequest_Params_CoverImage;
    case: "coverImage";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.Params.Cover.
 * Use `create(UpdateMyAccountRequest_Params_CoverSchema)` to create a new message.
 */
export const UpdateMyAccountRequest_Params_CoverSchema: GenMessage<UpdateMyAccountRequest_Params_Cover> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0, 0, 0);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest.Params.CoverImage
 */
export type UpdateMyAccountRequest_Params_CoverImage = Message<"protos.accounts.UpdateMyAccountRequest.Params.CoverImage"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * @generated from field: protos.accounts.ProfileCoverType cover_type = 2;
   */
  coverType: ProfileCoverType;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.Params.CoverImage.
 * Use `create(UpdateMyAccountRequest_Params_CoverImageSchema)` to create a new message.
 */
export const UpdateMyAccountRequest_Params_CoverImageSchema: GenMessage<UpdateMyAccountRequest_Params_CoverImage> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0, 0, 1);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest.Params.WorkFunctionData
 */
export type UpdateMyAccountRequest_Params_WorkFunctionData = Message<"protos.accounts.UpdateMyAccountRequest.Params.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.Params.WorkFunctionData.
 * Use `create(UpdateMyAccountRequest_Params_WorkFunctionDataSchema)` to create a new message.
 */
export const UpdateMyAccountRequest_Params_WorkFunctionDataSchema: GenMessage<UpdateMyAccountRequest_Params_WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0, 0, 2);

/**
 * @generated from message protos.accounts.UpdateMyAccountRequest.Params.InfoSheetLanguage
 */
export type UpdateMyAccountRequest_Params_InfoSheetLanguage = Message<"protos.accounts.UpdateMyAccountRequest.Params.InfoSheetLanguage"> & {
  /**
   * @generated from field: protos.general.SpokenLanguage language = 1;
   */
  language: SpokenLanguage;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountRequest.Params.InfoSheetLanguage.
 * Use `create(UpdateMyAccountRequest_Params_InfoSheetLanguageSchema)` to create a new message.
 */
export const UpdateMyAccountRequest_Params_InfoSheetLanguageSchema: GenMessage<UpdateMyAccountRequest_Params_InfoSheetLanguage> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 0, 0, 3);

/**
 * @generated from message protos.accounts.UpdateMyAccountResponse
 */
export type UpdateMyAccountResponse = Message<"protos.accounts.UpdateMyAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.UpdateMyAccountResponse.Result result = 1;
   */
  result?: UpdateMyAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMyAccountResponse.
 * Use `create(UpdateMyAccountResponseSchema)` to create a new message.
 */
export const UpdateMyAccountResponseSchema: GenMessage<UpdateMyAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 1);

/**
 * @generated from message protos.accounts.UpdateMyAccountResponse.Result
 */
export type UpdateMyAccountResponse_Result = Message<"protos.accounts.UpdateMyAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.UpdateMyAccountResponse.Result.
 * Use `create(UpdateMyAccountResponse_ResultSchema)` to create a new message.
 */
export const UpdateMyAccountResponse_ResultSchema: GenMessage<UpdateMyAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_account, 1, 0);

